import { Format } from './format.interface';
import { Card, Query } from '@deckplan.io/common';

export class Modern extends Format {

    public addCardsQuery(): Query {
        return {
            dataField: {
                title: 'Legalities',
                field: 'legalities',
                dataType: 'string'
            },
            operation: 'includes',
            value: `"modern":"legal"`
        };
    }

    public validate(): Card[] {
        return this.deck.cards.filter(c =>
            // All cards not legal in modern are invalid
            c.legalities.modern === 'not_legal'
        );
    }

}
